import { useCallback, useRef } from 'react';

/**
 * Serializes section creates so two quick Add Section clicks cannot race. The second create
 * has to name a real section as its anchor, and that id only exists once the first create has
 * answered — so creates run strictly in click order rather than in parallel.
 *
 * @returns {{ enqueueSectionCreate: (runCreate: () => Promise<void>) => Promise<void> }}
 */
export const useSectionCreateQueue = () => {
  const queueRef = useRef(Promise.resolve());

  const enqueueSectionCreate = useCallback((runCreate) => {
    const queuedCreate = queueRef.current.then(runCreate);

    // A rejected create must not poison the queue for the clicks waiting behind it.
    queueRef.current = queuedCreate.catch(() => undefined);

    return queuedCreate;
  }, []);

  return { enqueueSectionCreate };
};
